// extracted by mini-css-extract-plugin
export default {"model_heading":"style_model_heading__i2VZ-","model_description":"style_model_description__TT5Bq"};